import { DestTypes } from '@/shared/constants';
import { defineStore } from 'pinia';
import type { AppInfo } from '@/shared/yxhJsBridge';
import yxhJsBridge from '@/shared/yxhJsBridge';

export interface SettingsState {
  destType: DestTypes | null;
  appInfo: AppInfo;
}

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsState => ({
    /**
     * 分发类型
     */
    destType: null,
    /**
     * 应用信息
     */
    appInfo: {} as AppInfo,
  }),
  getters: {
    appInfoAcquired(state) {
      return Object.keys(state.appInfo).length > 0;
    },
  },
  actions: {
    updateDestType(payload: DestTypes) {
      this.destType = payload;
    },
    updateAppInfo(payload: AppInfo) {
      this.appInfo = payload;
    },
    /**
     * 获取应用信息
     */
    async getAppInfo() {
      const appInfo = await yxhJsBridge.getAppInfo();
      this.updateAppInfo(appInfo);
    },
  },
  persist: {
    paths: ['destType'],
  },
});
